import React, { FC, useCallback, useMemo, FocusEventHandler } from 'react'
import { IUseValidation, Input, InputGroup } from '@wmgtech/legato'
import { useController, useFormContext } from 'react-hook-form'
import { getNames } from './helpers'

import { cn } from 'shared/utils'

import { IEmailFieldProps } from './UserForm.props'

export const EmailField: FC<IEmailFieldProps> = ({ isExternalEmail, isCreate }) => {
  const {
    field,
    fieldState: { error }
  } = useController({ name: 'email' })

  const { setValue } = useFormContext()

  const validation = useMemo<IUseValidation | undefined>(
    () => {
      if (error) return {
        message: error.message,
        type: 'error'
      }
      if (isExternalEmail) return {
        message: 'User is outside of Warner Music Group. Will be marked as external.',
        type: 'warning',
      }
    },
    [error, isExternalEmail],
  )

  const handleBlur = useCallback<FocusEventHandler<HTMLInputElement>>(
    () => {
      if (!isExternalEmail && field.value) {
        try {
          const [firstName, lastName] = getNames(field.value)
          setValue('first_name', firstName)
          setValue('last_name', lastName)
        } catch {
          return
        }
      }
    },
    [field, isExternalEmail, setValue],
  )

  return (
    <InputGroup
      className={cn('form-input-group', { 'form-input-group__error': error })}
      label="Email"
      labelProps={{ icon: 'asterisk' }}
      validation={validation}
    >
      <Input
        placeholder="Email"
        autoComplete="off"
        {...field}
        onBlur={handleBlur}
        disabled={!isCreate}
        crossOrigin
      />
    </InputGroup>
  )
}
